import styled from "@emotion/styled";

export default styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
